<div class="fb-profile-container">
  <!-- Cover Photo & Profile Header -->
  <div class="fb-profile-header">
    <div class="fb-cover-photo">
      <!-- Cover image (using community cover if available, otherwise gradient) -->
      <div class="cover-image"
        [style.background-image]="getCoverPhotoUrl() ? 'url(' + getCoverPhotoUrl() + ')' : 'linear-gradient(135deg, #0e40d8 0%, #1a73e8 100%)'">
      </div>
      <button class="edit-cover-btn" *ngIf="activeTab() === 'community'" (click)="openCommunityEditModal()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path
            d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" />
          <circle cx="12" cy="13" r="4" />
        </svg>
        Editar portada
      </button>
    </div>

    <div class="fb-profile-info-section">
      <div class="fb-container">
        <div class="fb-profile-top">
          <!-- Profile Picture -->
          <div class="fb-profile-pic">
            <img
              [src]="getProfilePhotoUrl() || 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22168%22 height=%22168%22 viewBox=%220 0 168 168%22%3E%3Crect fill=%22%230e40d8%22 width=%22168%22 height=%22168%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 dominant-baseline=%22middle%22 text-anchor=%22middle%22 font-family=%22Arial, sans-serif%22 font-size=%2260%22 fill=%22white%22%3E' + getUserInitials() + '%3C/text%3E%3C/svg%3E'"
              [alt]="userInfo.name"
              (error)="$event.target.src='data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22168%22 height=%22168%22 viewBox=%220 0 168 168%22%3E%3Crect fill=%22%230e40d8%22 width=%22168%22 height=%22168%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 dominant-baseline=%22middle%22 text-anchor=%22middle%22 font-family=%22Arial, sans-serif%22 font-size=%2260%22 fill=%22white%22%3E' + getUserInitials() + '%3C/text%3E%3C/svg%3E'">
            <button class="edit-profile-pic-btn" *ngIf="activeTab() === 'community'" (click)="openCommunityEditModal()">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path
                  d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" />
                <circle cx="12" cy="13" r="4" />
              </svg>
            </button>
          </div>

          <!-- Profile Info -->
          <div class="fb-profile-name-section">
            <h1 class="fb-profile-name">
              {{ userInfo.name }}
              <span class="verified-badge" *ngIf="activeTab() === 'community' && communityProfile()?.verificado">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 12L11 14L15 10M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
                    fill="#0e40d8" stroke="#fff" stroke-width="2" />
                </svg>
              </span>
            </h1>
            <p class="fb-profile-subtitle" *ngIf="activeTab() === 'community' && communityProfile()?.nombre_usuario">
              @{{ communityProfile().nombre_usuario }}
            </p>
            @if (communityProfile()) {
            <div class="fb-profile-inline-stats">
              <span class="inline-stat" (click)="openFollowersList()">
                <strong>{{ communityProfile()?.total_seguidores || 0 }}</strong> seguidores
              </span>
              <span class="stat-dot">•</span>
              <span class="inline-stat" (click)="openFollowingList()">
                <strong>{{ communityProfile()?.total_seguidos || 0 }}</strong> seguidos
              </span>
            </div>
            }
            <p class="fb-profile-subtitle" *ngIf="activeTab() === 'info'">
              {{ userInfo.email }}
            </p>
          </div>
        </div>

        <!-- Navigation Tabs -->
        <div class="fb-profile-nav">
          <button class="fb-nav-tab" [class.active]="activeTab() === 'info'" (click)="setActiveTab('info')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
            Información
          </button>

          <button class="fb-nav-tab" [class.active]="activeTab() === 'payments'" (click)="setActiveTab('payments')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="2" y="5" width="20" height="14" rx="2" />
              <line x1="2" y1="10" x2="22" y2="10" />
            </svg>
            Pagos
          </button>

          <button class="fb-nav-tab" [class.active]="activeTab() === 'community'" (click)="setActiveTab('community')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path
                d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" />
              <circle cx="9" cy="7" r="4" />
              <path
                d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" />
              <path
                d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" />
            </svg>
            Comunidad
          </button>

          <button class="fb-nav-tab" [class.active]="activeTab() === 'referrals'" (click)="setActiveTab('referrals')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            Referidos
          </button>

          <button class="fb-nav-tab" [class.active]="activeTab() === 'blocked'" (click)="setActiveTab('blocked')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            Bloqueados
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="fb-profile-content">
    <div class="fb-container">
      <div class="fb-content-grid">
        <!-- LEFT SIDEBAR -->
        <aside class="fb-sidebar-left">
          <!-- Información Personal Tab -->
          @if (activeTab() === 'info') {
          <!-- Intro Card -->
          <div class="fb-card">
            <h3 class="fb-card-title">Introducción</h3>
            <div class="fb-intro-list">
              <div class="fb-intro-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path
                    d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" />
                  <path d="M22 6L12 13L2 6" />
                </svg>
                <span>{{ userInfo.email }}</span>
              </div>
              <div class="fb-intro-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                <span>Miembro desde {{ userInfo.memberSince }}</span>
              </div>
              <div class="fb-intro-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path
                    d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                </svg>
                <span>{{ userInfo.rol }}</span>
              </div>
            </div>
            <button class="fb-btn-secondary" (click)="openEditModal()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path
                  d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" />
                <path
                  d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" />
              </svg>
              Editar Información
            </button>
          </div>

          <!-- Plan Card -->
          <div class="fb-card">
            <div class="fb-plan-header">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                  fill="#FFD700" stroke="#FFD700" stroke-width="2" />
              </svg>
              <h3 class="fb-card-title">{{ planInfo.nombre }}</h3>
            </div>
            <p class="fb-plan-price" *ngIf="planInfo.precio !== '0'">${{ planInfo.precio }} / {{ planInfo.duracionDias
              }} días</p>
            <p class="fb-plan-price" *ngIf="planInfo.precio === '0'">Plan Gratuito</p>
            <div class="fb-plan-desc" [innerHTML]="planInfo.descripcion"></div>

            <div class="fb-subscription-status">
              <span class="status-label">Estado:</span>
              <span class="status-badge" [style.background]="getEstadoColor(suscripcionInfo.estado)">
                {{ suscripcionInfo.estado }}
              </span>
            </div>

            <div class="fb-date-range">
              <div class="date-item">
                <span class="date-label">Inicio</span>
                <span class="date-value">{{ formatDate(suscripcionInfo.fechaInicio) }}</span>
              </div>
              <div class="date-item">
                <span class="date-label">Fin</span>
                <span class="date-value">{{ formatDate(suscripcionInfo.fechaFin) }}</span>
              </div>
            </div>
          </div>
          }

          <!-- Community Tab -->
          @if (activeTab() === 'community' && communityProfile()) {
          <div class="fb-card">
            <h3 class="fb-card-title">Sobre mí</h3>
            <p class="fb-bio">{{ communityProfile().biografia || 'Sin biografía' }}</p>

            <div class="fb-intro-list">
              <div class="fb-intro-item" *ngIf="communityProfile().ciudad">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path
                    d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <span>Vive en <strong>{{ communityProfile().ciudad }}</strong></span>
              </div>

              <div class="fb-intro-item" *ngIf="communityProfile().sitio_web">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10" />
                  <path
                    d="M2 12H22M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z" />
                </svg>
                <a [href]="communityProfile().sitio_web" target="_blank" class="fb-link">
                  {{ communityProfile().sitio_web }}
                </a>
              </div>

              <div class="fb-intro-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6V12L16 14" />
                </svg>
                <span>Se unió el {{ formatDate(communityProfile().fecha_creacion) }}</span>
              </div>
            </div>

            <button class="fb-btn-secondary" (click)="openCommunityEditModal()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path
                  d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" />
                <path
                  d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" />
              </svg>
              Editar Perfil
            </button>
          </div>

          <!-- Stats Card -->
          <div class="fb-card">
            <h3 class="fb-card-title">Estadísticas</h3>
            <div class="fb-stats-grid">
              <div class="fb-stat">
                <span class="stat-number">{{ communityProfile().total_publicaciones || 0 }}</span>
                <span class="stat-label">Publicaciones</span>
              </div>
              <div class="fb-stat clickable-stat" (click)="openFollowersList()">
                <span class="stat-number">{{ communityProfile().total_seguidores || 0 }}</span>
                <span class="stat-label">Seguidores</span>
              </div>
              <div class="fb-stat clickable-stat" (click)="openFollowingList()">
                <span class="stat-number">{{ communityProfile().total_seguidos || 0 }}</span>
                <span class="stat-label">Siguiendo</span>
              </div>
            </div>
          </div>
          }
        </aside>

        <!-- RIGHT CONTENT -->
        <main class="fb-main-content">
          <!-- Información Personal Content -->
          @if (activeTab() === 'info') {
          <!-- Quick Actions -->
          <div class="fb-card">
            <h3 class="fb-card-title">Acciones Rápidas</h3>
            <div class="fb-actions-grid">
              <button class="fb-action-btn" (click)="openPasswordModal()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" />
                  <path
                    d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" />
                </svg>
                <span>Cambiar Contraseña</span>
              </button>
            </div>
          </div>

          <!-- Dispositivos -->
          <div class="fb-card">
            <div class="fb-card-header">
              <h3 class="fb-card-title">Dispositivos Vinculados</h3>
              <span class="fb-badge">{{ dispositivosActivos }}/3 activos</span>
            </div>

            @if (loadingDispositivos) {
            <div class="fb-loading">
              <svg class="spinner" width="40" height="40" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25" />
                <path d="M12 2C6.47715 2 2 6.47715 2 12" stroke="currentColor" stroke-width="4"
                  stroke-linecap="round" />
              </svg>
            </div>
            }

            @if (!loadingDispositivos && dispositivos.length > 0) {
            <div class="fb-devices-list">
              @for (dispositivo of dispositivos; track dispositivo.id_dispositivo) {
              <div class="fb-device-item" [class.inactive]="!dispositivo.activo"
                [class.current]="dispositivo.es_dispositivo_actual">
                <div class="device-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="2" y="3" width="20" height="14" rx="2" />
                    <path d="M8 21H16" />
                    <path d="M12 17V21" />
                  </svg>
                </div>
                <div class="device-info">
                  <h4 class="device-name">
                    {{ dispositivo.nombre_dispositivo }}
                    @if (dispositivo.es_dispositivo_actual) {
                    <span class="current-badge">Actual</span>
                    }
                  </h4>
                  <p class="device-meta">{{ dispositivo.tipo_dispositivo }} • {{ dispositivo.ip_dispositivo }}</p>
                  <p class="device-date">Último acceso: {{ formatFecha(dispositivo.ultimo_acceso) }}</p>
                </div>
                <button class="fb-btn-icon" (click)="verHistorialIPs(dispositivo)">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 6V12L16 14" />
                  </svg>
                </button>
              </div>
              }
            </div>
            }

            @if (!loadingDispositivos && dispositivos.length === 0) {
            <div class="fb-empty-state">
              <p>No hay dispositivos registrados</p>
            </div>
            }
          </div>

          <!-- Alertas de Seguridad -->
          <div class="fb-card">
            <div class="fb-card-header">
              <h3 class="fb-card-title">Alertas de Seguridad</h3>
              @if (alertas.length > 0) {
              <span class="fb-badge-alert">{{ alertas.length }}</span>
              }
            </div>

            @if (loadingAlertas) {
            <div class="fb-loading">
              <svg class="spinner" width="40" height="40" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25" />
                <path d="M12 2C6.47715 2 2 6.47715 2 12" stroke="currentColor" stroke-width="4"
                  stroke-linecap="round" />
              </svg>
            </div>
            }

            @if (!loadingAlertas && alertas.length > 0) {
            <div class="fb-alerts-list">
              @for (alerta of alertas; track alerta.id_alerta) {
              <div class="fb-alert-item" [style.border-left-color]="getSeveridadColor(alerta.severidad)">
                <div class="alert-header">
                  <span class="alert-icon">{{ getSeveridadIcono(alerta.severidad) }}</span>
                  <span class="alert-severity" [style.color]="getSeveridadColor(alerta.severidad)">
                    {{ alerta.severidad }}
                  </span>
                  <span class="alert-date">{{ formatFecha(alerta.fecha_alerta) }}</span>
                </div>
                <p class="alert-message">{{ alerta.mensaje }}</p>
              </div>
              }
            </div>
            }

            @if (!loadingAlertas && alertas.length === 0) {
            <div class="fb-empty-state-success">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path
                  d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7088 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
              <p>Sin alertas de seguridad</p>
              <small>Tu cuenta está segura</small>
            </div>
            }
          </div>
          }

          <!-- Pagos Content -->
          @if (activeTab() === 'payments') {
          <div class="fb-card">
            <div class="fb-coming-soon">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                <circle cx="40" cy="40" r="38" stroke="rgba(14, 64, 216, 0.3)" stroke-width="4" />
                <rect x="20" y="28" width="40" height="24" rx="2" stroke="rgba(14, 64, 216, 0.6)" stroke-width="3" />
                <line x1="20" y1="36" x2="60" y2="36" stroke="rgba(14, 64, 216, 0.6)" stroke-width="3" />
              </svg>
              <h3 class="coming-soon-title">Próximamente</h3>
              <p class="coming-soon-text">El historial de pagos estará disponible pronto. Podrás ver todas tus
                transacciones, descargar facturas y gestionar tus métodos de pago.</p>
            </div>
          </div>
          }

          <!-- Community Content -->
          @if (activeTab() === 'community') {
          @if (isLoadingCommunity()) {
          <div class="fb-card">
            <div class="fb-loading">
              <svg class="spinner" width="60" height="60" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25" />
                <path d="M12 2C6.47715 2 2 6.47715 2 12" stroke="currentColor" stroke-width="4"
                  stroke-linecap="round" />
              </svg>
              <p>Cargando perfil de comunidad...</p>
            </div>
          </div>
          }

          @if (!isLoadingCommunity() && communityProfile()) {
          <!-- Quick Actions -->
          <div class="fb-card">
            <h3 class="fb-card-title">Acciones de Comunidad</h3>
            <div class="fb-actions-grid">
              <button class="fb-action-btn" (click)="goToCommunityFeed()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" />
                </svg>
                <span>Ir al Feed</span>
              </button>

              <button class="fb-action-btn" (click)="goToPublicProfile()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 16V12M12 8H12.01" />
                </svg>
                <span>Ver Perfil Público</span>
              </button>
            </div>
          </div>

          <!-- Privacy Settings -->
          <div class="fb-card">
            <h3 class="fb-card-title">Privacidad</h3>
            <div class="fb-privacy-item">
              <div class="privacy-info">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  @if (communityProfile().es_perfil_publico) {
                  <circle cx="12" cy="12" r="10" />
                  <path
                    d="M2 12H22M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z" />
                  } @else {
                  <rect x="3" y="11" width="18" height="11" rx="2" />
                  <path
                    d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" />
                  }
                </svg>
                <div>
                  <h4 class="privacy-title">Perfil {{ communityProfile().es_perfil_publico ? 'Público' : 'Privado' }}
                  </h4>
                  <p class="privacy-desc">
                    @if (communityProfile().es_perfil_publico) {
                    Cualquier persona puede ver tu perfil y publicaciones
                    } @else {
                    Solo las personas que sigues pueden ver tu perfil
                    }
                  </p>
                </div>
              </div>
              <span class="status-badge" [class.public]="communityProfile().es_perfil_publico"
                [class.private]="!communityProfile().es_perfil_publico">
                {{ communityProfile().es_perfil_publico ? 'Público' : 'Privado' }}
              </span>
            </div>
          </div>
          }

          @if (!isLoadingCommunity() && !communityProfile()) {
          <div class="fb-card">
            <div class="fb-empty-state">
              <p>No se pudo cargar el perfil de comunidad</p>
              <button class="fb-btn-secondary" (click)="loadCommunityProfile()">Reintentar</button>
            </div>
          </div>
          }
          }

          <!-- Referrals Content -->
          @if (activeTab() === 'referrals') {
          @if (isLoadingReferrals()) {
          <div class="fb-card">
            <div class="fb-loading">
              <svg class="spinner" width="60" height="60" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25" />
                <path d="M12 2C6.47715 2 2 6.47715 2 12" stroke="currentColor" stroke-width="4"
                  stroke-linecap="round" />
              </svg>
              <p>Cargando datos de referidos...</p>
            </div>
          </div>
          } @else {
          <!-- Mi Código de Referido -->
          <div class="fb-card">
            <h3 class="fb-card-title">💰 Programa de Referidos</h3>
            <p class="referral-intro">Comparte tu código con amigos y gana comisiones por cada referido.</p>

            <div class="referral-code-section">
              <div class="code-group">
                <label class="code-label">Tu código de referido:</label>
                <div class="code-display-group">
                  <span class="code-value">{{ codigoReferido() || 'Cargando...' }}</span>
                  <button class="btn-copy" (click)="copiarCodigoReferido()" title="Copiar código">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="9" y="9" width="13" height="13" rx="2" />
                      <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                    </svg>
                    Copiar
                  </button>
                </div>
              </div>

              <div class="link-group">
                <label class="code-label">Link para compartir:</label>
                <div class="link-display-group">
                  <input type="text" readonly [value]="linkReferido() || 'Cargando...'" class="link-input">
                  <button class="btn-copy" (click)="copiarLinkReferido()" title="Copiar link">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="9" y="9" width="13" height="13" rx="2" />
                      <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                    </svg>
                  </button>
                </div>
              </div>

              <button class="btn-whatsapp" (click)="compartirWhatsApp()">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                Compartir por WhatsApp
              </button>
            </div>
          </div>

          <!-- Configuración de Wallet Crypto -->
          <div class="fb-card">
            <h3 class="fb-card-title">💎 Wallet para Recibir Comisiones</h3>
            @if (isLoadingWallet()) {
            <p>Cargando información de wallet...</p>
            } @else if (walletInfo() && walletInfo()!.wallet_configurada) {
            <div class="wallet-configured">
              <div class="wallet-info-display">
                <div class="wallet-icon-badge">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="1" y="4" width="22" height="16" rx="2" />
                    <path d="M1 10h22" />
                  </svg>
                </div>
                <div class="wallet-details">
                  <div class="wallet-type">
                    <span class="crypto-badge">{{ walletInfo()!.wallet_tipo }}</span>
                    <span class="network-badge">{{ walletInfo()!.wallet_red }}</span>
                    @if (walletInfo()!.wallet_verificada) {
                    <span class="verified-badge">✓ Verificada</span>
                    }
                  </div>
                  <div class="wallet-address-display">
                    <code class="wallet-address">{{ walletInfo()!.wallet_crypto_address }}</code>
                    <button class="btn-copy-small" (click)="copiarDireccionWallet()" title="Copiar dirección">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <rect x="9" y="9" width="13" height="13" rx="2" />
                        <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                      </svg>
                    </button>
                  </div>
                  <span class="wallet-date">Configurada el {{ formatDate(walletInfo()!.wallet_fecha_registro) }}</span>
                </div>
              </div>
              <div class="wallet-actions">
                <button class="fb-btn-secondary" (click)="abrirModalWallet()">
                  Editar Wallet
                </button>
                @if (!walletInfo()!.wallet_verificada) {
                <button class="fb-btn-primary" (click)="verificarWallet()">
                  Verificar Wallet
                </button>
                }
                <button class="fb-btn-danger" (click)="eliminarWallet()">
                  Eliminar
                </button>
              </div>
            </div>
            } @else {
            <div class="wallet-not-configured">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                opacity="0.3">
                <rect x="1" y="4" width="22" height="16" rx="2" />
                <path d="M1 10h22" />
              </svg>
              <p>No tienes una wallet configurada</p>
              <p class="wallet-subtitle">Configura tu wallet para recibir comisiones de tus referidos</p>
              <button class="fb-btn-primary" (click)="abrirModalWallet()">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 5v14M5 12h14" />
                </svg>
                Configurar Wallet
              </button>
            </div>
            }
          </div>

          <!-- Resumen de Comisiones -->
          @if (referralData()) {
          <div class="fb-card">
            <h3 class="fb-card-title">📊 Resumen de Comisiones</h3>
            <div class="comisiones-grid">
              <div class="comision-card">
                <div class="comision-icon total">💰</div>
                <div class="comision-info">
                  <span class="comision-value">{{ formatearMonto(referralData().resumen_comisiones?.total_generado || 0)
                    }}</span>
                  <span class="comision-label">Total Generado</span>
                </div>
              </div>
              <div class="comision-card">
                <div class="comision-icon cobrado">✅</div>
                <div class="comision-info">
                  <span class="comision-value">{{ formatearMonto(referralData().resumen_comisiones?.total_cobrado || 0)
                    }}</span>
                  <span class="comision-label">Ya Cobrado</span>
                </div>
              </div>
              <div class="comision-card">
                <div class="comision-icon pendiente">⏳</div>
                <div class="comision-info">
                  <span class="comision-value">{{ formatearMonto(referralData().resumen_comisiones?.pendiente_cobro ||
                    0) }}</span>
                  <span class="comision-label">Pendiente de Cobro</span>
                </div>
              </div>
            </div>

            <div class="estados-summary">
              <div class="estado-item">
                <span class="estado-badge pendiente">{{ referralData().resumen_estados?.pendientes || 0 }}</span>
                <span>Pendientes</span>
              </div>
              <div class="estado-item">
                <span class="estado-badge aprobada">{{ referralData().resumen_estados?.aprobadas || 0 }}</span>
                <span>Aprobadas</span>
              </div>
              <div class="estado-item">
                <span class="estado-badge pagada">{{ referralData().resumen_estados?.pagadas || 0 }}</span>
                <span>Pagadas</span>
              </div>
            </div>
          </div>

          <!-- Lista de Referidos -->
          <div class="fb-card">
            <h3 class="fb-card-title">👥 Mis Referidos ({{ referralData().total_referidos || 0 }})</h3>
            @if (referralData().referidos && referralData().referidos.length > 0) {
            <div class="referidos-list">
              @for (ref of referralData().referidos; track ref.id_referido) {
              <div class="referido-item">
                <div class="referido-avatar">
                  @if (ref.usuario?.foto_perfil) {
                  <img [src]="getProfilePhotoUrlForUser(ref.usuario.foto_perfil)" [alt]="ref.usuario.nombre_completo">
                  } @else {
                  <span>{{ (ref.usuario?.nombre_completo || 'U').substring(0, 1).toUpperCase() }}</span>
                  }
                </div>
                <div class="referido-info">
                  <div class="referido-header">
                    <span class="referido-name">{{ ref.usuario?.nombre_completo }}</span>
                    <span class="referido-username">@{{ ref.usuario?.nombre_usuario }}</span>
                  </div>
                  <div class="referido-details">
                    <span class="referido-date">📅 {{ formatDate(ref.fecha_registro) }}</span>
                    @if (ref.plan_comprado) {
                    <span class="referido-plan">📦 {{ ref.plan_comprado.nombre_plan }}</span>
                    }
                  </div>
                  @if (ref.nota) {
                  <span class="referido-nota">📝 {{ ref.nota }}</span>
                  }
                </div>
                <div class="referido-comision">
                  <span class="comision-monto">{{ formatearMonto(ref.monto_comision) }}</span>
                  <span class="comision-estado" [class]="getComisionBadgeClass(ref.estado_comision)">
                    {{ ref.estado_comision }}
                  </span>
                  @if (ref.fecha_pago) {
                  <span class="fecha-pago">Pagado: {{ formatDate(ref.fecha_pago) }}</span>
                  }
                </div>
              </div>
              }
            </div>
            } @else {
            <div class="fb-empty-state">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path
                  d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
              <p>Aún no tienes referidos</p>
              <p class="empty-subtitle">Comparte tu código y empieza a ganar comisiones</p>
            </div>
            }
          </div>
          }
          }
          }

          <!-- Blocked Users Content -->
          @if (activeTab() === 'blocked') {
          @if (isLoadingBlockedUsers()) {
          <div class="fb-card">
            <div class="fb-loading">
              <svg class="spinner" width="60" height="60" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25" />
                <path d="M12 2C6.47715 2 2 6.47715 2 12" stroke="currentColor" stroke-width="4"
                  stroke-linecap="round" />
              </svg>
              <p>Cargando usuarios bloqueados...</p>
            </div>
          </div>
          } @else {
          <div class="fb-card">
            <h3 class="fb-card-title">Usuarios Bloqueados</h3>
            @if (blockedUsers().length > 0) {
            <div class="blocked-users-list">
              @for (blocked of blockedUsers(); track blocked.id_bloqueo) {
              <div class="blocked-user-item">
                <div class="blocked-user-info">
                  <div class="blocked-user-avatar">
                    @if (blocked.bloqueado.foto_perfil) {
                    <img [src]="getProfilePhotoUrlForUser(blocked.bloqueado.foto_perfil)"
                      [alt]="blocked.bloqueado.nombre">
                    } @else {
                    <span>{{ (blocked.bloqueado.nombre || 'U').substring(0, 1).toUpperCase() }}</span>
                    }
                  </div>
                  <div class="blocked-user-details">
                    <span class="blocked-user-name">{{ blocked.bloqueado.nombre }}@if (blocked.bloqueado.apellido) {
                      {{ blocked.bloqueado.apellido }}}</span>
                    <span class="blocked-user-username">@{{ blocked.bloqueado.nombre_usuario }}</span>
                    <span class="blocked-user-date">Bloqueado el {{ formatDate(blocked.fecha_bloqueo) }}</span>
                    @if (blocked.motivo) {
                    <span class="blocked-user-reason">Motivo: {{ blocked.motivo }}</span>
                    }
                  </div>
                </div>
                <button class="fb-btn-danger" (click)="blocked.bloqueado && unblockUser(blocked.bloqueado.id_usuario)">
                  Desbloquear
                </button>
              </div>
              }
            </div>
            } @else {
            <div class="fb-empty-state">
              <p>No tienes usuarios bloqueados</p>
            </div>
            }
          </div>
          }
          }
        </main>
      </div>
    </div>
  </div>

  <!-- Modals (mantener los existentes) -->
  <!-- Modal de Edición -->
  <div class="modal-overlay" *ngIf="showEditModal()" (click)="closeEditModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">Editar Información</h2>
        <button class="modal-close" (click)="closeEditModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>

      <form class="modal-form" (ngSubmit)="updateUserInfo()">
        <!-- Mensaje de error -->
        <div class="alert alert-error" *ngIf="errorMessage">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
            <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
          {{ errorMessage }}
        </div>

        <!-- Mensaje de éxito -->
        <div class="alert alert-success" *ngIf="successMessage">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7088 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          {{ successMessage }}
        </div>

        <div class="form-group">
          <label for="nombre" class="form-label">Nombre</label>
          <input type="text" id="nombre" name="nombre" class="form-input" [(ngModel)]="editForm.nombre"
            placeholder="Ingresa tu nombre" required [disabled]="isSubmitting">
        </div>

        <div class="form-group">
          <label for="apellido" class="form-label">Apellido</label>
          <input type="text" id="apellido" name="apellido" class="form-input" [(ngModel)]="editForm.apellido"
            placeholder="Ingresa tu apellido" required [disabled]="isSubmitting">
        </div>

        <div class="form-group">
          <label for="email" class="form-label">Email</label>
          <input type="email" id="email" name="email" class="form-input" [(ngModel)]="editForm.email"
            placeholder="Ingresa tu email" required [disabled]="isSubmitting">
        </div>

        <div class="modal-actions">
          <button type="button" class="btn-cancel" (click)="closeEditModal()" [disabled]="isSubmitting">
            Cancelar
          </button>
          <button type="submit" class="btn-save" [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">Guardar Cambios</span>
            <span *ngIf="isSubmitting" class="loading-text">
              <svg class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25" />
                <path d="M12 2C6.47715 2 2 6.47715 2 12" stroke="currentColor" stroke-width="4"
                  stroke-linecap="round" />
              </svg>
              Guardando...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Modal de Cambio de Contraseña -->
  <div class="modal-overlay" *ngIf="showPasswordModal()" (click)="closePasswordModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">Cambiar Contraseña</h2>
        <button class="modal-close" (click)="closePasswordModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>

      <form class="modal-form" (ngSubmit)="changePassword()">
        <!-- Mensaje de error -->
        <div class="alert alert-error" *ngIf="passwordErrorMessage">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
            <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
          {{ passwordErrorMessage }}
        </div>

        <!-- Mensaje de éxito -->
        <div class="alert alert-success" *ngIf="passwordSuccessMessage">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7088 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          {{ passwordSuccessMessage }}
        </div>

        <div class="form-group">
          <label for="currentPassword" class="form-label">Contraseña Actual</label>
          <div class="password-input-wrapper">
            <input [type]="showCurrentPassword ? 'text' : 'password'" id="currentPassword" name="currentPassword"
              class="form-input password-input" [(ngModel)]="passwordForm.currentPassword"
              placeholder="Ingresa tu contraseña actual" required [disabled]="isSubmittingPassword">
            <button type="button" class="password-toggle" (click)="togglePasswordVisibility('current')"
              [disabled]="isSubmittingPassword">
              <svg *ngIf="!showCurrentPassword" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <svg *ngIf="showCurrentPassword" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06M9.9 4.24C10.5883 4.0789 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.4811 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4858 9.58525 10.1546 9.88 9.88"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>

        <div class="form-group">
          <label for="newPassword" class="form-label">Nueva Contraseña</label>
          <div class="password-input-wrapper">
            <input [type]="showNewPassword ? 'text' : 'password'" id="newPassword" name="newPassword"
              class="form-input password-input" [(ngModel)]="passwordForm.newPassword"
              placeholder="Ingresa tu nueva contraseña" required minlength="6" [disabled]="isSubmittingPassword">
            <button type="button" class="password-toggle" (click)="togglePasswordVisibility('new')"
              [disabled]="isSubmittingPassword">
              <svg *ngIf="!showNewPassword" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <svg *ngIf="showNewPassword" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06M9.9 4.24C10.5883 4.0789 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.4811 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4858 9.58525 10.1546 9.88 9.88"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>
          <small class="form-hint">Mínimo 6 caracteres</small>
        </div>

        <div class="form-group">
          <label for="confirmPassword" class="form-label">Confirmar Nueva Contraseña</label>
          <div class="password-input-wrapper">
            <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword" name="confirmPassword"
              class="form-input password-input" [(ngModel)]="passwordForm.confirmPassword"
              placeholder="Confirma tu nueva contraseña" required [disabled]="isSubmittingPassword">
            <button type="button" class="password-toggle" (click)="togglePasswordVisibility('confirm')"
              [disabled]="isSubmittingPassword">
              <svg *ngIf="!showConfirmPassword" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <svg *ngIf="showConfirmPassword" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06M9.9 4.24C10.5883 4.0789 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.4811 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4858 9.58525 10.1546 9.88 9.88"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>

        <div class="modal-actions">
          <button type="button" class="btn-cancel" (click)="closePasswordModal()" [disabled]="isSubmittingPassword">
            Cancelar
          </button>
          <button type="submit" class="btn-save" [disabled]="isSubmittingPassword">
            <span *ngIf="!isSubmittingPassword">Cambiar Contraseña</span>
            <span *ngIf="isSubmittingPassword" class="loading-text">
              <svg class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25" />
                <path d="M12 2C6.47715 2 2 6.47715 2 12" stroke="currentColor" stroke-width="4"
                  stroke-linecap="round" />
              </svg>
              Cambiando...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Modal de Historial de IPs -->
  <div class="modal-overlay" *ngIf="showHistorialModal()" (click)="closeHistorialModal()">
    <div class="modal-content modal-historial" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">Historial de IPs</h2>
        <button class="modal-close" (click)="closeHistorialModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>

      <div class="modal-form" *ngIf="dispositivoHistorial">
        <!-- Info del dispositivo -->
        <div class="historial-device-info">
          <h3>{{dispositivoHistorial.nombre_dispositivo}}</h3>
          <div class="device-status-row">
            <div class="status-item">
              <span class="label">IP Actual:</span>
              <span class="value">{{dispositivoHistorial.ip_actual}}</span>
            </div>
            <div class="status-item">
              <span class="label">Cambios de IP:</span>
              <span class="value">{{dispositivoHistorial.contador_cambios}}</span>
            </div>
            <div class="status-item" *ngIf="dispositivoHistorial.bloqueado">
              <span class="label">Estado:</span>
              <span class="value blocked">🚨 BLOQUEADO</span>
            </div>
          </div>
        </div>

        <!-- Lista de cambios -->
        <div class="historial-list">
          <div class="historial-header">
            <h4>Historial de Cambios</h4>
          </div>

          <div *ngIf="historialSeleccionado.length === 0" class="historial-empty">
            <p>No hay cambios de IP registrados</p>
          </div>

          <div *ngFor="let cambio of historialSeleccionado" class="historial-item">
            <div class="cambio-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
                <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
              <span class="cambio-fecha">{{formatFecha(cambio.fecha_cambio)}}</span>
              <span class="alerta-badge" *ngIf="cambio.alerta_enviada">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M10.29 3.86L1.82 18C1.64537 18.3024 1.55296 18.6453 1.55198 18.9945C1.55101 19.3437 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23675 20.5467 2.53773 20.7239C2.83871 20.9011 3.18082 20.9963 3.53 21H20.47C20.8192 20.9963 21.1613 20.9011 21.4623 20.7239C21.7633 20.5467 22.0126 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5317 3.56611 13.2807 3.32312 12.9812 3.15448C12.6817 2.98585 12.3438 2.89725 12 2.89725C11.6562 2.89725 11.3183 2.98585 11.0188 3.15448C10.7193 3.32312 10.4683 3.56611 10.29 3.86Z"
                    stroke="currentColor" stroke-width="2" />
                </svg>
                Alerta enviada
              </span>
            </div>
            <div class="cambio-details">
              <div class="ip-change">
                <span class="ip-anterior">{{cambio.ip_anterior || 'Primera IP'}}</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                  <polyline points="12 5 19 12 12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <span class="ip-nueva">{{cambio.ip_nueva}}</span>
              </div>
            </div>
          </div>
        </div>

        <button class="btn-close-historial" (click)="closeHistorialModal()">
          Cerrar
        </button>
      </div>
    </div>
  </div>

  <!-- Modal de Edición de Perfil de Comunidad -->
  <div class="modal-overlay" *ngIf="showCommunityEditModal()" (click)="closeCommunityEditModal()">
    <div class="modal-content modal-community-edit" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">Editar Perfil de Comunidad</h2>
        <button class="modal-close" (click)="closeCommunityEditModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>

      <form class="modal-form community-edit-form" (ngSubmit)="saveCommunityProfile()">
        <!-- Mensaje de error -->
        <div class="alert alert-error" *ngIf="communityErrorMessage">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
            <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
          {{ communityErrorMessage }}
        </div>

        <!-- Mensaje de éxito -->
        <div class="alert alert-success" *ngIf="communitySuccessMessage">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7088 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          {{ communitySuccessMessage }}
        </div>

        <!-- Foto de portada -->
        <div class="form-section">
          <h3 class="section-title">Foto de Portada</h3>
          <div class="cover-photo-upload">
            <div class="cover-preview"
              [style.background-image]="coverPhotoPreview ? 'url(' + coverPhotoPreview + ')' : 'linear-gradient(135deg, #0e40d8 0%, #1a73e8 100%)'">
              <label for="cover-photo-input" class="upload-overlay">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path
                    d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" />
                  <circle cx="12" cy="13" r="4" />
                </svg>
                <span>Cambiar portada</span>
              </label>
              <input type="file" id="cover-photo-input" accept="image/*" (change)="handleCoverPhotoSelect($event)"
                style="display: none;" [disabled]="isSubmittingCommunity">
            </div>
          </div>
        </div>

        <!-- Foto de perfil -->
        <div class="form-section">
          <h3 class="section-title">Foto de Perfil</h3>
          <div class="profile-photo-upload">
            <div class="profile-preview">
              <img [src]="profilePicturePreview || 'https://i.pravatar.cc/150?img=1'" alt="Profile">
              <label for="profile-photo-input" class="upload-btn-overlay">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path
                    d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" />
                  <circle cx="12" cy="13" r="4" />
                </svg>
              </label>
              <input type="file" id="profile-photo-input" accept="image/*" (change)="handleProfilePictureSelect($event)"
                style="display: none;" [disabled]="isSubmittingCommunity">
            </div>
          </div>
        </div>

        <!-- Información básica -->
        <div class="form-section">
          <h3 class="section-title">Información Básica</h3>

          <div class="form-group">
            <label for="nombre_usuario" class="form-label">Nombre de Usuario *</label>
            <input type="text" id="nombre_usuario" name="nombre_usuario" class="form-input"
              [(ngModel)]="communityEditForm.nombre_usuario" placeholder="@tunombredeusuario" required
              [disabled]="isSubmittingCommunity">
          </div>

          <div class="form-group">
            <label for="biografia" class="form-label">Biografía *</label>
            <textarea id="biografia" name="biografia" class="form-textarea" [(ngModel)]="communityEditForm.biografia"
              placeholder="Cuéntanos sobre ti..." rows="4" required [disabled]="isSubmittingCommunity"></textarea>
          </div>

          <div class="form-group">
            <label for="ciudad" class="form-label">Ciudad</label>
            <input type="text" id="ciudad" name="ciudad" class="form-input" [(ngModel)]="communityEditForm.ciudad"
              placeholder="Tu ciudad" [disabled]="isSubmittingCommunity">
          </div>

          <div class="form-group">
            <label for="sitio_web" class="form-label">Sitio Web</label>
            <input type="url" id="sitio_web" name="sitio_web" class="form-input"
              [(ngModel)]="communityEditForm.sitio_web" placeholder="https://tusitioweb.com"
              [disabled]="isSubmittingCommunity">
          </div>
        </div>

        <!-- Privacidad -->
        <div class="form-section">
          <h3 class="section-title">Privacidad</h3>

          <div class="form-group-checkbox">
            <label class="checkbox-label">
              <input type="checkbox" name="es_perfil_publico" [(ngModel)]="communityEditForm.es_perfil_publico"
                [disabled]="isSubmittingCommunity">
              <span class="checkbox-custom"></span>
              <span class="checkbox-text">
                <strong>Perfil Público</strong>
                <small>Permite que otros usuarios vean tu perfil y publicaciones</small>
              </span>
            </label>
          </div>
        </div>

        <div class="modal-actions">
          <button type="button" class="btn-cancel" (click)="closeCommunityEditModal()"
            [disabled]="isSubmittingCommunity">
            Cancelar
          </button>
          <button type="submit" class="btn-save" [disabled]="isSubmittingCommunity">
            <span *ngIf="!isSubmittingCommunity">Guardar Cambios</span>
            <span *ngIf="isSubmittingCommunity" class="loading-text">
              <svg class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25" />
                <path d="M12 2C6.47715 2 2 6.47715 2 12" stroke="currentColor" stroke-width="4"
                  stroke-linecap="round" />
              </svg>
              Guardando...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Modal de Configuración de Wallet -->
<div class="modal-overlay" *ngIf="showWalletModal()" (click)="cerrarModalWallet()">
  <div class="modal-content wallet-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">💎 Configurar Wallet de Crypto</h2>
      <button class="modal-close" (click)="cerrarModalWallet()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <p class="wallet-modal-intro">
        Configura tu wallet de criptomonedas para recibir las comisiones generadas por tus referidos.
      </p>

      <div class="form-group">
        <label class="form-label">Tipo de Criptomoneda</label>
        <select class="form-select" [value]="walletForm().tipo"
          (change)="onTipoCryptoChange($any($event.target).value)">
          @for (tipo of tiposCrypto(); track tipo.tipo) {
          <option [value]="tipo.tipo">{{ tipo.nombre }} ({{ tipo.tipo }})</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">Red</label>
        <select class="form-select" [value]="walletForm().red" (change)="onRedChange($any($event.target).value)">
          @for (red of getRedesDisponibles(walletForm().tipo); track red) {
          <option [value]="red">{{ red }}</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">Dirección de Wallet</label>
        <input type="text" class="form-input wallet-address-input" placeholder="Ej: TXYZoPYKcsVnMwZXhkVqWgHFGmBv7Pqzxy"
          [value]="walletForm().address" (input)="onAddressChange($any($event.target).value)">
        <small class="form-hint">
          Asegúrate de que la dirección sea correcta. Los pagos enviados a una dirección incorrecta no se pueden
          recuperar.
        </small>
      </div>

      <div class="wallet-warning">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          <path d="M12 9v4M12 17h.01" />
        </svg>
        <div>
          <strong>Importante:</strong> Verifica que la dirección sea correcta antes de guardar.
          Las transacciones de criptomonedas son irreversibles.
        </div>
      </div>
    </div>

    <div class="modal-actions">
      <button class="btn-cancel" (click)="cerrarModalWallet()">
        Cancelar
      </button>
      <button class="btn-save" (click)="guardarWallet()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
          <path d="M17 21v-8H7v8M7 3v5h8" />
        </svg>
        Guardar Wallet
      </button>
    </div>
  </div>
  <!-- User List Modal (Followers/Following) -->
  @if (showUserListModal()) {
  <div class="user-list-modal-overlay" (click)="closeUserListModal()">
    <div class="user-list-modal-container" (click)="$event.stopPropagation()">
      <div class="user-list-modal-header">
        <h3>{{ userListType() === 'followers' ? 'Seguidores' : 'Siguiendo' }}</h3>
        <button class="close-user-list-modal-btn" (click)="closeUserListModal()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6L18 18" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>

      <div class="user-list-modal-body custom-scrollbar">
        @if (isLoadingUserList() && userListItems().length === 0) {
        <div class="user-list-modal-loading-state">
          <div class="user-list-spinner-small"></div>
          <p>Cargando lista...</p>
        </div>
        } @else if (userListItems().length === 0) {
        <div class="user-list-modal-empty-state">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path
              d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
          <p>No hay usuarios para mostrar</p>
        </div>
        } @else {
        <div class="user-list-container">
          @for (user of userListItems(); track user.id_usuario) {
          <div class="user-list-modal-item">
            <div class="user-list-item-info" (click)="goToUser(user.id_usuario)">
              <img [src]="user.foto_perfil || 'https://api.dicebear.com/7.x/avataaars/svg?seed=' + user.nombre"
                class="user-list-item-avatar">
              <div>
                <h4 class="user-list-item-name">{{ user.nombre_completo || user.nombre || 'Usuario' }}</h4>
                <span class="user-list-item-username">@{{ user.nombre_usuario || 'sin_usuario' }}</span>
              </div>
            </div>

            @if (user.id_usuario !== userIdActual()) {
            <button class="btn-follow-sm" [class.following]="user.siguiendo" (click)="toggleFollowInList(user)">
              {{ user.siguiendo ? 'Siguiendo' : 'Seguir' }}
            </button>
            }
          </div>
          }
        </div>

        @if (hasMoreUserList()) {
        <div class="user-list-modal-footer-action">
          <button class="btn-text-sm" (click)="loadUserList(true)">
            Cargar más usuarios
          </button>
        </div>
        }
        }
      </div>
    </div>
  </div>
  }
</div>